import CreateBusiness from '@/views/factoring/CreateBusiness.vue'
import BeforeFacture from '@/views/factoring/NewBeforeFacture.vue'
import Stats from '@/views/factoring/Stats.vue'
import PersonalData from '@/views/factoring/NewMyinfo.vue'

export default [
  {
    path: 'estadisticas',
    name: 'stats',
    component: Stats,
  },
  {
    path: 'anticipo-facturas',
    name: 'anticipo-facture',
    component: BeforeFacture,
     meta: { requireUserValid: true },
	},
	//Profile stuffs
  {
    path: 'cuenta-banco',
    name: 'My-info-acount-bank',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/NewMyinfo.vue'),
  },
  {
    path:'mis-claves',
    name: 'My-keys-acount-bank',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/Mypass.vue'),
  },
  {
    path: 'createbussiness',
    name: 'create-bussiness',
    component: CreateBusiness,
  },
  {
    path: 'empresas',
    name: 'bussiness',
    component: () => import(/* webpackChunkName: "busines" */ '@/views/factoring/Business.vue'),
  },
  {
    path: 'mis-operaciones',
    name: 'my-operation',
    component: () => import(/* webpackChunkName: "busines" */ '@/views/factoring/MyOperationsRequests.vue'),
    meta: { requireUserValid: true },
  },
  {
    path: 'ceder-facturas',
    name: 'ceder-facture',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/FactureCeder.vue'),
    meta: { requireUserValid: true },
  },
  {
    path: 'datos-personales',
    name: 'personal-data',
    component: PersonalData,
  },
  {
    path: 'editar-empresa/:companyId',
    name: 'edit-business',
    component: () => import( /* webpackChunkName: "edit-business" */ '@/views/dashboard/EditBusiness.vue'),
    props: true,
  },
  {
    path: 'controlar-cuentas',
    name: 'controlar-cuentas',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/factoring/admin/ControlAccount.vue'),
  },
  {
    path: 'mis-cupos',
    name: 'mis-cupos',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/factoring/NewCreditLine.vue'),
    meta: { requireUserValid: true },
  },
  {
    path: "administrar-usuarios",
    name: "administrar-usuarios",
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/preparador/PreparadorAprobador.vue'),
    meta: { requireUserValid: true },
  },
  {
    path: "reportes",
    name: "reportes",
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/reports/Reportes.vue'),
    meta: { requireUserValid: true },
  },
]